import { useEffect } from 'react';

import { DeviceInfo } from '@ezugi/utils/src';

import { EVENTS } from '../constants/postMessage';
import { logDevelopmentError } from '../util/logDevelopmentError';
import { postMessage } from '../util/postMessage';
import { useFullscreen } from './useFullscreen';

const NODE_ENV = import.meta.env.MODE;

const disableAutoFullscreen = /^true$/i.test(
  import.meta.env.VITE_DISABLE_FULLSCREEN ?? (NODE_ENV === 'development' ? 'true' : 'false')
);

export default function useFullscreenOnTouch() {
  const [ , toggleFullscreen ] = useFullscreen();

  useEffect(() => {
    const handleTouchEnd = () => {
      try {
        if (DeviceInfo.isHandheld && !disableAutoFullscreen) {
          toggleFullscreen(true);
        }
        postMessage({ event: EVENTS.MOBILE_USER_INTERACTION }, false);
      } catch (e) {
        const message = e instanceof Error ? e.message : 'Unknown error';
        logDevelopmentError(message);
      }
    };

    document.addEventListener('touchend', handleTouchEnd, { capture: true, passive: true });

    return () => document.removeEventListener('touchend', handleTouchEnd, { capture: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
